<template>
  <div class="jobList">
    <div class="wrap">
      <!-- <div class="banner"><img src="../assets/img/banner2.jpg" /></div> -->
      <div class="page_tit">
        <h4>{{ $t("others.latestjob") }}</h4>
      </div>
      <div class="where_title">
        <div class="search">
          <el-input v-model="queryList1.queryContent" :placeholder="$t('others.inputtext1')" />
          <el-button type="primary" @click="handlebtnQuery()"><i class="el-icon-search fs20"></i></el-button>
        </div>
        <div class="where_pc_list">
          <div class="item">
            <span class="tit">{{ $t("others.worklocation") }}：</span>
            <div class="flex1">
              <ul :class="cityMore ? 'ul_line1' : ''">
                <li @click="getArea2(-100)" :class="isAllList ? 'active' : ''"><span
                    v-html="language === 'zh' ? '不限' : 'No limit'"></span></li>
                <!-- <li v-for="(item, index) in areaData" :key="index" v-if="index < 10"
                  :class="selectedCityActive == index ? 'active' : ''" @click="selectedCityActive = index; getArea2(item)">
                  <span>{{ item.label }}</span>
                </li> -->
                <li v-for="(item, index) in cityList" :key="index" :class="selectedCityActive == index ? 'active' : ''"
                  @click="selectedCityActive = index; getArea2(item)">
                  <span v-html="language === 'zh' ? item.cn : item.en"></span>
                </li>
              </ul>
              <div class="li_more" @click="cityMore = !cityMore">
                <!-- <span @click="dialogVisible = true">更多城市></span> -->
                <span v-if="cityMore" v-html="language === 'zh' ? '更多城市>' : 'more>'"></span>
                <span v-else v-html="language === 'zh' ? '<收起' : '< retract'"></span>
              </div>
            </div>
          </div>
          <!-- <div class="item">
            <span class="tit">行业分类：</span>
            <div class="flex1">
              <ul>
                <li><span>不限</span></li>
                <li><span>计算机/互联网/通信/电子</span></li>
                <li><span>房地产/建筑/工程</span></li>
                <li><span>会计/金融/银行/保险</span></li>
                <li><span>广告/媒体</span></li>
                <li><span>制药/医疗/卫生</span></li>
                <li><span>贸易/批发/零售</span></li>
                <li><span>制造业</span></li>
                <li><span>物流/运输</span></li>
              </ul>
              <div class="li_more">
                <span>更多></span>
              </div>
            </div>
          </div>
          <div class="item">
            <span class="tit">职位类别：</span>
            <div class="flex1">
              <ul>
                <li><span>不限</span></li>
                <li><span>销售/商务拓展</span></li>
                <li><span>人事/行政/财务/法务</span></li>
                <li><span>互联网技术/通信及硬件</span></li>
                <li><span>运维/测试</span></li>
                <li><span>视觉/交互/设计</span></li>
                <li><span>运营/专业分析</span></li>
                <li><span>产品/项目/高级管理</span></li>
              </ul>
              <div class="li_more">
                <span>更多></span>
              </div>
            </div>
          </div> -->
          <div class="item">
            <span class="tit" style="width: 80x;">{{ $t("others.salaryrange") }}：</span>
            <div class="flex1">
              <ul>
                <li style="cursor: pointer" @click="getRowId(item)" v-for="(item) in salarylist" :key="item.value"
                  :class="item.value == salaryvalue ? 'active' : ''">
                  {{ language == "zh" ? item.label : item.enlabel }}
                </li>
              </ul>
            </div>
          </div>
          <div class="item">
            <span class="tit">{{ $t("others.moreconditon2") }}：</span>
            <div class="flex1">
              <el-select @change="handlebtnQuery()" v-model="queryList1.education"
                :placeholder="$t('others.morecondition11')">
                <el-option v-for="item in education" :key="item.value"
                  :label="language === 'zh' ? item.label : item.enlabel" :value="item.value">
                </el-option>
              </el-select>
              <el-select @change="handlebtnQuery()" v-model="queryList1.experience"
                :placeholder="$t('others.morecondition12')">
                <el-option v-for="item in experience" :key="item.value"
                  :label="language === 'zh' ? item.label : item.enlabel" :value="item.value">
                </el-option>
              </el-select>
              <el-select @change="handlebtnQuery()" v-model="queryList1.companyIndustry"
                :placeholder="$t('others.morecondition13')">
                <el-option v-for="item in companyIndustry" :key="item.value"
                  :label="language === 'zh' ? item.label : item.enlabel" :value="item.value">
                </el-option>
              </el-select>
              <el-select @change="handlebtnQuery()" v-model="queryList1.companySize"
                :placeholder="$t('others.morecondition14')">
                <el-option v-for="item in companySize" :key="item.value"
                  :label="language === 'zh' ? item.label : item.enlabel" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <span class="tit">{{ $t("others.moreconditon") }}：</span>
            <div class="flex1">
              <ul class="ul_check">
                <!-- <li>工作地点：北京<i  class="el-icon-close"></i></li> -->
                <li class="showcity" v-if="selectedCityList != null">
                  <label v-html="language === 'zh' ? ' 工作地点：' : 'Work location:'"></label>
                  <label v-if="cityStr" v-html="language === 'zh' ? cityStr.cn : cityStr.en"></label>
                  <i class="el-icon-close" @click="resetClick()"></i>
                </li>
                <li id="showsalary" v-show="salaryvalue >= 0">
                  <label v-html="language === 'zh' ? ' 薪资范围:' : 'Salary range:'"></label>
                  {{ salaryLabel }}
                  <i class="el-icon-close" @click="closesalary()"></i>
                </li>
                <li id="temp" v-show="false"><i class="el-icon-close"></i></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="where_wap_list filter-container">
          <ul class="top-list">
            <li class="list-item" @click="drawer = true">
              <div class="icon">
                <div class="t-icon t-icon1"></div>
              </div>
              <p class="name" v-html="language == 'zh' ? '工作地点' : 'Work location'"></p>
              <label class="lbl" v-if="cityStr" v-html="language === 'zh' ? cityStr.cn : cityStr.en"></label>

            </li>
            <li class="list-item" @click="drawer2 = true">
              <div class="icon">
                <div class="t-icon t-icon2"></div>
              </div>
              <p class="name" v-html="language == 'zh' ? '薪资范围' : 'Salary range'"></p>
              <label class="lbl">{{ salaryLabel }}</label>
            </li>
            <li class="list-item" @click="drawer3 = true">
              <div class="icon">
                <div class="t-icon t-icon4"></div>
              </div>
              <p class="name" v-html="language == 'zh' ? '更多筛选' : 'More options'"></p>
            </li>
          </ul>
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in datalist" :key="index" :class="item.type == 0 ? 'item_ad' : ''">
          <div class="box" v-if="item.id > 0" :class="'box' + item.id">
            <a :href="'#/jobApply?id=' + item.id + '&lang=' + lang" target="_blank">
              <label class="type" :class="'type' + item.id"></label>
              <h3 class="ellipsis">{{ item.jobname }}</h3>
              <p v-html="item.jobinfo"></p>
            </a>
          </div>
          <div v-else><img src="../assets/img/bgtop.jpg" /></div>
        </div>
        <div class="item"></div>
      </div>
      <div class="more" @click="loadMore">
        <!--  <span style="background-color:white;color:gray;"></span>  -->
      </div>
    </div>

    <!--    <el-dialog title="" :visible.sync="dialogVisible" width="750px" :before-close="handleClose">-->
    <el-dialog title="" :visible.sync="dialogVisible" width="750px">
      <div class="dialog-cont">
        <div class="tit">
          <span class="span_tit">请选择所属城市</span>
          <el-autocomplete class="el-input" v-model="state2" :fetch-suggestions="querySearch" placeholder="请输入内容"
            :trigger-on-focus="false" @select="handleSelect"></el-autocomplete>
        </div>
        <div class="flex">
          <div class="cont">
            <ul>
              <li v-for="(item, index) in areaData" :key="index" :class="province == index ? 'active' : ''" @click="
                province = index;
              bindArea();
              ">
                {{ item.label }}<i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>
          <div class="cont">
            <ul>
              <li v-for="(item, index) in cityData" :key="index" :class="city == index ? 'active' : ''" @click="
                city = index;
              bindArea();
              getArea(item);
              ">
                {{ item.label }}<i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>
          <!-- <div class="flex_ht">
            <ul class="flex1_ul">
              <li
                v-if="districtsData.length > 0"
                @click="
                  cityData[city].isAll = !cityData[city].isAll;
                  getArea(-100);
                "
                :class="cityData[city].isAll ? 'active' : ''"
              >
                全部
              </li>
              <li
                v-for="(item, index) in districtsData"
                :key="index"
                :class="item.check ? 'active' : ''"
                @click="getArea(item)"
              >
                {{ item.label }}
              </li>
            </ul>
          </div> -->
        </div>
        <div class="result_b">
          <span class="span_tit">已选城市：</span>
          <div class="flex1">
            <ul class="ul_check2">
              <li class="showcity" v-if="selectedCityList != null">
                {{ cityStr
                }}<i class="el-icon-close" @click="removeThis()"></i>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetClick()">重 置</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer :title="language == 'zh' ? '选择城市' : 'Select City'" :visible.sync="drawer" direction="ltr" size="100%">
      <div class="dialog-cont2">
        <div class="city_wap_list">
          <ul>
            <li @click="getArea2(-100)" :class="isAllList ? 'active' : ''"><span
                v-html="language === 'zh' ? '不限' : 'No limit'"></span></li>
            <li v-for="(item, index) in cityList" :key="index" :class="selectedCityActive2 == index ? 'active' : ''"
              @click="selectedCityActive2 = index; getArea2(item)">
              <span v-html="language === 'zh' ? item.cn : item.en"></span>
            </li>
          </ul>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button @click="resetClick" v-html="language == 'zh' ? '重 置' : 'reset'"></el-button>
        <el-button type="primary" @click="drawer = false" v-html="language == 'zh' ? '确 定' : 'confirm'"></el-button>
      </div>
    </el-drawer>

    <el-drawer :title="language == 'zh' ? '薪资范围' : 'Salary range'" :visible.sync="drawer2" direction="ltr" size="100%">
      <div class="dialog-cont dialog-cont2">
        <div class="city_wap_list list_col">
          <ul>
            <li style="cursor: pointer" @click="getRowId(item)" v-for="(item) in salarylist" :key="item.value"
              :class="item.value == salaryvalue ? 'active' : ''">
              {{ language == "zh" ? item.label : item.enlabel }}
            </li>
          </ul>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="closesalary" v-html="language == 'zh' ? '重 置' : 'reset'"></el-button>
        <el-button type="primary" @click="drawer2 = false" v-html="language == 'zh' ? '确 定' : 'confirm'"></el-button>

      </div>
    </el-drawer>

    <el-drawer :title="$t('others.moreconditon')" :visible.sync="drawer3" direction="ltr" size="100%">
      <div class="dialog-cont dialog-cont2">
        <div :class="language === 'zh'?'flex':'flex flex_en'" >
          <div class="cont">
            <ul>
              <li :class="drawer3_active==0?'active':''" @click="drawer3_active=0" v-html="$t('others.morecondition11')"></li> 
              <li :class="drawer3_active==1?'active':''" @click="drawer3_active=1" v-html="$t('others.morecondition12')"></li> 
              <li :class="drawer3_active==2?'active':''" @click="drawer3_active=2" v-html="$t('others.morecondition13')"></li> 
              <li :class="drawer3_active==3?'active':''" @click="drawer3_active=3" v-html="$t('others.morecondition14')"></li>  
            </ul>
          </div>
          <div class="flex_ht">
            <div class="col" v-if="drawer3_active==0">
              <h3>{{ $t('others.morecondition11') }}</h3>
              <ul>
                <li :class="queryList1.educationInd==index?'active':''" @click="queryList1.educationInd=index" v-for="(item,index) in education" :key="item.value" v-html="language === 'zh' ? item.label : item.enlabel" >
                </li>
              </ul>
            </div>
            <div class="col" v-if="drawer3_active==1">
              <h3>{{ $t('others.morecondition12') }}</h3>
              <ul>
                <li :class="queryList1.experienceInd==index?'active':''" @click="queryList1.experienceInd=index" v-for="(item,index) in experience" :key="item.value" v-html="language === 'zh' ? item.label : item.enlabel" >
                </li>
              </ul>
            </div>
            <div class="col" v-if="drawer3_active==2">
              <h3>{{ $t('others.morecondition13') }}</h3>
              <ul>
                <li :class="queryList1.companyIndustryInd==index?'active':''" @click="queryList1.companyIndustryInd=index" v-for="(item,index) in companyIndustry" :key="item.value" v-html="language === 'zh' ? item.label : item.enlabel" >
                </li>
              </ul>
            </div>
            <div class="col" v-if="drawer3_active==3">
              <h3>{{ $t('others.morecondition14') }}</h3>
              <ul>
                <li :class="queryList1.companySizeInd==index?'active':''" @click="queryList1.companySizeInd=index" v-for="(item,index) in companySize" :key="item.value" v-html="language === 'zh' ? item.label : item.enlabel" >
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="resetDrawer3">重 置</el-button>
        <el-button @click="drawer3=false" type="primary">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";

import { regionData } from "element-china-area-data";
export default {
  data() {
    return {
      datalist: [],
      page: 1,
      lang: "",
      language: this.$i18n.locale,//"zh",
      keyword: "kevinq",
      input: "",
      item1: false,
      item2: false,
      item3: false,
      salaryvalue: -1,
      salaryLabel: '',
      salarylist: [
        {
          value: 1,
          label: "不限",
          enlabel: "No restriction",
        },
        {
          value: 2,
          label: "1万-2万",
          enlabel: "£1000-2000 per month",
        },
        {
          value: 3,
          label: "2万-3万",
          enlabel: "£2000-3000 per month",
        },
        {
          value: 4,
          label: "3万-4万",
          enlabel: "£3000-4000 per month",
        },
        {
          value: 5,
          label: "4万-5万",
          enlabel: "£4000-5000 per month",
        },
        {
          value: 6,
          label: "5万-10万",
          enlabel: "£5000-10000 per month",
        },
        {
          value: 7,
          label: "10万以上",
          enlabel: "Over 10000 per month",
        },
        {
          value: 8,
          label: "面议",
          enlabel: "Negotiable",
        },
      ],
      education: [
        {
          value: "不限",
          label: "不限",
          enlabel: "No restriction",
        },
        {
          value: "博士后",
          label: "博士后",
          enlabel: "Postdoctoral fellow",
        },
        {
          value: "博士",
          label: "博士",
          enlabel: "Doctor",
        },
        {
          value: "MBA/EMBA",
          label: "MBA/EMBA",
          enlabel: "MBA/EMBA",
        },
        {
          value: "硕士",
          label: "硕士",
          enlabel: "Master",
        },
        {
          value: "本科",
          label: "本科",
          enlabel: "Bachelor",
        },
      ],
      companyIndustry: [
        {
          value: "中央企业",
          label: "中央企业",
          enlabel: "Central Enterprise",
        },
        {
          value: "国有企业",
          label: "国有企业",
          enlabel: "State-owned Enterprise",
        },
        {
          value: "中外合资",
          label: "中外合资",
          enlabel: "Joint Venture between Chinese and Foreign Entities",
        },
        {
          value: "民营/私企",
          label: "民营/私企",
          enlabel: "Private Enterprise / Privately-owned Company",
        },
        {
          value: "上市公司",
          label: "上市公司",
          enlabel: "Public Company / Listed Company",
        },
        {
          value: "股份制企业",
          label: "股份制企业",
          enlabel: "Joint Stock Company",
        },
        {
          value: "外企独资",
          label: "外企独资",
          enlabel: "Foreign-owned Enterprise / Wholly Foreign-owned Enterprise",
        },
        {
          value: "政府机关/非盈利组织",
          label: "政府机关/非盈利组织",
          enlabel: "",
        },
        {
          value: "事业单位",
          label: "事业单位",
          enlabel: "Public Institution",
        },
        {
          value: "民非组织",
          label: "民非组织",
          enlabel: "Social Service Organization",
        },
      ],
      companySize: [
        {
          value: "1-9人",
          label: "1-9人",
          enlabel: "1-9",
        },
        {
          value: "10-99人",
          label: "10-99人",
          enlabel: "10-99",
        },
        {
          value: "100-499人",
          label: "100-499人",
          enlabel: "100-499",
        },
        {
          value: "499-1000人",
          label: "499-1000人",
          enlabel: "499-1000",
        },
        {
          value: "1000人以上",
          label: "1000人以上",
          enlabel: "Over 1000",
        },
      ],
      experience: [
        {
          value: "不限",
          label: "不限",
          enlabel: "No restriction",
        },
        {
          value: "无需经验",
          label: "无需经验",
          enlabel: "No experience required",
        },
        {
          value: "1年以下",
          label: "1年以下",
          enlabel: "Less than one year",
        },
        {
          value: "1-3年",
          label: "1-3年",
          enlabel: "1 to 3 years",
        },
        {
          value: "3-5年",
          label: "3-5年",
          enlabel: "3 to 5 years",
        },
        {
          value: "5-10年",
          label: "5-10年",
          enlabel: "5 to 10 years",
        },
        {
          value: "10年以上",
          label: "10年以上",
          enlabel: "Over 10 years",
        },
      ],
      options: [
        {
          value: "博士",
          label: "博士",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      isAllList: false,
      areaData: [],
      province: -1,
      provinceData: [], //省
      city: -1,
      cityData: [], //市
      districts: -1,
      // districtsData: [], //区
      selectedCityList: null,
      selectedCityActive: -1,
      dialogVisible: false,
      drawer: false,
      drawer2: false,
      drawer3: false,
      queryList1: {
        pageId: 0,
        queryContent: "",
        companyIndustry: "",
        companyIndustryInd:-1,
        companySize: "",
        companySizeInd:-1,
        experience: "",
        experienceInd:-1,
        education: "",
        educationInd:-1,
        salarylist: "",
        location: "",
      },

      state2: "",
      cityStr: "",
      selectedCityActive2: -1,
      cityMore: true,
      cityList: [
        { cn: '北京市', en: 'Beijing' },
        { cn: '天津市', en: 'Tianjin' },
        { cn: '上海市', en: 'Shanghai' },
        { cn: '重庆市', en: 'Chongqing' },
        { cn: '安徽省', en: 'Anhui' },
        { cn: '福建省', en: 'Fujian' },
        { cn: '甘肃省', en: 'Gansu' },
        { cn: '广东省', en: 'Guangdong' },
        { cn: '贵州省', en: 'Guizhou' },
        { cn: '海南省', en: 'Hainan' },
        { cn: '河北省', en: 'Hebei' },
        { cn: '河南省', en: 'Henan' },
        { cn: '黑龙江省', en: 'Heilongjiang' },
        { cn: '湖北省', en: 'Hubei' },
        { cn: '湖南省', en: 'Hunan' },
        { cn: '吉林省', en: 'Jilin' },
        { cn: '江苏省', en: 'Jiangsu' },
        { cn: '江西省', en: 'Jiangxi' },
        { cn: '辽宁省', en: 'Liaoning' },
        { cn: '青海省', en: 'Qinghai' },
        { cn: '山东省', en: 'Shandong' },
        { cn: '山西省', en: 'Shanxi' },
        { cn: '陕西省', en: 'Shaanxi' },
        { cn: '四川省', en: 'Sichuan' },
        { cn: '云南省', en: 'Yunnan' },
        { cn: '浙江省', en: 'Zhejiang' },
        { cn: '广西壮族自治区', en: 'Guangxi Zhuang Autonomous Region' },
        { cn: '内蒙古自治区', en: 'Inner Mongolia Autonomous Region' },
        { cn: '宁夏回族自治区', en: 'Ningxia Hui Autonomous Region' },
        { cn: '西藏自治区', en: 'Tibet Autonomous Region' },
        { cn: '新疆维吾尔自治区', en: 'Xinjiang Uygur Autonomous Region' },
      ], 
      drawer3_active: 0
    };
  },
  computed: {
    language2() {
      return this.$i18n.locale;
    },
  },
  watch: {
    language2: function (a, b) {
      this.language = a
    },

  },
  components: {},
  created() {
    this.loading = false;
    this.handleQuery();
    this.areaData = regionData;
    this.bindArea();
  },
  mounted() {
    // 监听页面滚动
    window.onscroll = this.pageScroll;
    document.addEventListener("mousemove", this.handleMouseMove);
    //this.language = this.$i18n.locale;
  },
  methods: {
    handleMouseMove(event) {
      // 在这里处理逻辑，例如更新全局状态等
      this.lang = this.$i18n.locale;
    },
    loadMore() {
      this.page = this.page + 1;
      this.handleQuery();
    },
    pageScroll() {
      // 获取滚动的距离
      let scrollTop = document.documentElement.scrollTop;
      // 获取滚动的高度（获取整个html的高度）
      let scrollHeight = document.documentElement.scrollHeight;
      // 获取屏幕(浏览器)高度
      let clienHeight = document.documentElement.clientHeight;
      // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
      if (scrollTop + clienHeight - (scrollHeight - 100) >= 0) {
        console.log("我到底了");
        this.offset++;
        //滚动至底部后请求数据
        this.loadMore();
      }
    },
    closesalary() {
      this.salaryvalue = -1;
      this.salaryLabel = '';
      this.queryList1.salarylist = "";
      this.handlebtnQuery();
    },
    // getRowId(rowId) {
    //   if (this.salaryvalue == true) {
    //     if (!this.queryList1.salarylist.includes(rowId))
    //       this.queryList1.salarylist = this.queryList1.salarylist + "," + rowId;
    //     console.log("11111111111");
    //     console.log(this.queryList1.salarylist);
    //   } else {
    //     this.salaryvalue = true;
    //     this.queryList1.salarylist = rowId;
    //     console.log("222222222");
    //     console.log(this.queryList1.salarylist);
    //   }
    //   document.getElementById("showsalary").innerHTML =
    //     "薪资范围:" +
    //     this.queryList1.salarylist +
    //     document.getElementById("temp").innerHTML;

    //   this.handlebtnQuery();
    // },
    getRowId(item) {
      this.salaryvalue = item.value
      if (this.language == "zh") {
        this.salaryLabel = item.label;
      }
      else {
        this.salaryLabel = item.enlabel;
      }
    },
    handlebtnQuery() {
      // 点击查询按钮清空原有查询结果

      this.page = 1;
      this.datalist = [];
      this.handleQuery();
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true;
      console.log('111111111122222222');

      console.log(this.cityStr);

      this.lang = this.$i18n.locale;
      let param = new FormData();
      param = {
        pageId: this.page,
        queryContent: this.queryList1.queryContent,
        education: this.queryList1.education,
        companyIndustry: this.queryList1.companyIndustry,
        companySize: this.queryList1.companySize,
        experience: this.queryList1.experience,
        salarylist: this.salaryLabel,
        location: this.cityStr.val,
        language: this.lang,
      };
      this.$http
        .post(
           "https://test2.uc-elink.co.uk/api/Content/GetCasesByPageId",
           //   "http://localhost:6879/api/Content/GetCasesByPageId",
          param,
          {
            "Content-Type": "application/json;charset=UTF-8",
          }
        )
        .then((response) => {
          console.log(param);
          var text = response.data.replace(/[\r|\n|\t]/g, "");
          // this.datalist = JSON.parse(text);
          console.log("1111111111");
          console.log(text);
          var queryList = JSON.parse(text);

          queryList.forEach((item, index) => {
            this.datalist.push(item);
          });
          //for (i = 0; i <= 9; i++) {
          //  this.datalist.push(queryList[i]);
          // }
          console.log("1111111111aaaaaaa");
        });
    },
    bindArea() {
      this.districts = -1;
      if (this.province >= 0)
        this.cityData = this.areaData[this.province].children;
      // if (this.city >= 0)
      //   this.districtsData = this.cityData[this.city].children;
    },
    getArea(item) {

      if (item != -100) {

        if (this.areaData[this.province]) item.val = "";
        item.val += this.areaData[this.province].label + "|";
        // if (this.cityData[this.city])
        //   item.val += this.cityData[this.city].label + "|";
        item.val += item.label;
        this.selectedCityList = item;
      } else {
        this.selectedCityList = null
      }
      // this.districts = item.value;
      item.check = !item.check;

      this.cityStr = this.selectedCityList.val || this.selectedCityList.value;
    },
    getArea2(item) {
      if (item != -100) {

        item.val = this.language == 'zh' ? item.cn : item.en;
        this.selectedCityList = item;

        this.districts = item.value;
        item.check = !item.check;
      } else {
        this.isAllList = !this.isAllList;
        if (this.isAllList) {
          let arr = {
            label: null,
            val: "不限",
            val_en: 'No limit'
          };
          this.selectedCityList = arr
        } else {
          this.selectedCityList = null
        }
      }
      this.cityStr = this.selectedCityList;
      console.log(this.selectedCityList)
    },
    removeThis(item) {
      item.check = false;
      this.selectedCityList = null
      this.cityStr = "";
    },
    resetClick() {
      this.isAllList = false
      this.areaData = regionData;
      this.province = -1;
      this.cityData.forEach((i) => {
        i.isAll = false;
      });
      this.cityList.forEach((i) => {
        i.check = false;
      });
      this.cityData = [];
      this.city = -1;
      this.districts = -1;
      // this.districtsData.forEach((i) => {
      //   i.check = false;
      // });
      // this.districtsData = [];
      this.selectedCityList = null;
      this.cityStr = "";
      this.selectedCityActive2 = -1;
    },
    querySearch(queryString, cb) {
      var restaurants = this.loadAll();
      console.log(restaurants);
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    loadAll() {
      let arr = [];
      this.areaData.forEach((item) => {
        if (item.children) {
          item.children.forEach((ite) => {
            arr.push({ label: ite.value, value: item.label + "|" + ite.label });
            if (ite.children) {
              ite.children.forEach((it) => {
                arr.push({
                  label: it.value,
                  value: item.label + "|" + ite.label + "|" + it.label,
                });
              });
            }
          });
        }
      });
      return arr;
    },
    handleSelect(item) {

      let arr = this.selectedCityList.filter((i) => i.label == item.label);
      console.log(arr, item, this.selectedCityList);
      if (arr.length == 0) this.selectedCityList.push(item);

      this.cityStr = "";
      this.selectedCityList.forEach((i) => {
        this.cityStr += i.val + ",";
      });
      this.cityStr = this.cityStr.substr(0, this.cityStr.length - 1);
    },
    resetDrawer3(){
      this.queryList1= {
        pageId: 0,
        queryContent: "",
        companyIndustry: "",
        companyIndustryInd:-1,
        companySize: "",
        companySizeInd:-1,
        experience: "",
        experienceInd:-1,
        education: "",
        educationInd:-1,
        salarylist: "",
        location: "",
      }
    }
  },
};
</script>
<style lang="scss" scoped></style>
<style>
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 20ch;
  /* 设置最大宽度为20个字符宽度 */
}

.ul_line1 {
  height: 35px;
  overflow: hidden;
}

.city_wap_list {
  padding: 20px;
  width: 100% !important;
  box-sizing: border-box;
  overflow-y: auto;
  height: calc(100vh - 150px);
}

.city_wap_list ul {
  display: flex;
  flex-wrap: wrap;
  width: 100% !important;
}

.city_wap_list li {
  padding: 3px 8px;
  margin: 5px 5px !important;
  width: initial !important;
}

.city_wap_list li.active {
  background: #ececec !important;
  color: rgb(237, 26, 34)
}

.where_wap_list P {
  line-height: 1;
  margin-top: 15px;
}

.where_wap_list .lbl {
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-size: 14px;
  white-space: nowrap;
  color: #001567;
}

.where_wap_list li {
  position: relative;
}

.city_wap_list.list_col li {
  flex: 0 0 100%
}
.dialog-cont2 .flex_en .cont li{line-height:20px;padding-top: 10px ;padding-bottom: 10px;padding-right: 10px;box-sizing: border-box;}
.dialog-cont2 .flex_en ul li{width: 100%;line-height: 20px;padding: 10px;}
.dialog-cont2 .flex .col ul li.active{color:  rgb(237, 26, 34);}
</style>